import { InteractionRequiredAuthError } from "@azure/msal-browser";

export const userHasRequiredRole = (account, requiredRole) => {
  if (!account || !account.idTokenClaims) return false;
  const roles = account.idTokenClaims.roles || [];
  return roles.includes(requiredRole);
};

export const acquireToken = async (msalInstance, account) => {
  const request = {
    scopes: ["4f76332f-798f-45bb-a7b8-83d869286233/.default"],
    account: account,
  };
  try {
    const response = await msalInstance.acquireTokenSilent(request);
    return response;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect(request);
      return new Promise(() => {});
    }
    throw error;
  }
};
